import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import classNames from "classnames";

import Container from "../Container";
// import RichtextRenderer from "../RichtextRenderer";
import Button from "../basic/Button";
import { useApplyAfterWidth } from "../../utils/hooks";

// const RenderImage = ({ image }) => {
//   return image?.gatsbyImageData ? (
//     <GatsbyImage
//       image={image.gatsbyImageData}
//       alt={image.title}
//       objectFit="cover"
//       quality={100}
//       className="h-full w-full"
//       imgClassName="object-left-top"
//     />
//   ) : image ? (
//     <div className="h-full w-full relative">
//       <img className="absolute inset-0 h-full w-full object-cover" src={image} alt={"News Preview"} />
//     </div>
//   ) : (
//     <StaticImage
//       src={"../../images/media-releases/logo-media.png"}
//       alt="Logo"
//       quality={100}
//       objectFit="cover"
//       className="h-full w-full"
//     />
//   );
// };

const NewsElement = ({
  title,
  image,
  date,
  slug,
  className,
  isBigCard = false,
  showPreviewText,
  size = "sm",
  mostRecentLabel,
  mostRecentImage,
  ...rest
}) => {
  // const shortText = rest?.summary || rest?.content || "";

  // const preview = !showPreviewText ? null : (
  //   <div className="mt-24px">
  //     {shortText?.raw ? (
  //       <RichtextRenderer
  //         data={shortText}
  //         className={"line-clamp-4"}
  //         config={{
  //           p: "!text-blue",
  //         }}
  //       />
  //     ) : (
  //       <div className="line-clamp-2" dangerouslySetInnerHTML={{ __html: shortText }} />
  //     )}
  //   </div>
  // );

  return (
    <div
      className={classNames(
        "relative overflow-hidden hover:brightness-95",
        {
          "!h-460px": size === "sm" && isBigCard,
          "rounded-t-8px md:rounded-t-none md:!rounded-r-8px": isBigCard,
        },
        className,
      )}
    >
      <Link to={`/news/${slug}`}>
        <div
          className={classNames(
            "relative overflow-hidden",
            {
              "!h-460px": size === "sm" && isBigCard,
            },
            className,
          )}
        >
          {isBigCard && (
            <>
              <div className="absolute left-0 top-0 w-full h-full z-[1]">
                <GatsbyImage
                  image={mostRecentImage.gatsbyImageData}
                  alt={mostRecentImage.title}
                  quality={100}
                  objectFit="fill"
                  className="w-full h-full"
                />
              </div>
              <div className="absolute z-[2] bg-blue bg-opacity-60 h-full w-full" />
              <div
                className="absolute z-[3] top-36px right-36px py-16px px-24px border-white border text-[#EBEEF3]
               leading-[140%] button-text"
              >
                {mostRecentLabel}
              </div>
            </>
          )}
          <div
            className={classNames("relative z-[2]", {
              blur__xs: size === "xs" && isBigCard,
              "-right-16px -bottom-16px blur__sm": size === "sm" && isBigCard,
              "-right-65px -bottom-26px": size === "xl" && isBigCard,
            })}
          />
          <div
            className={classNames("flex flex-col gap-12px relative z-[3] h-full", {
              "text-white justify-end pb-32px px-32px": isBigCard,
              "text-blue py-12px !flex-col md:!flex-row md:items-center": !isBigCard,
            })}
          >
            {!isBigCard && (
              <div className="py-32px w-174px bg-[#E9F0F2] flex md:items-center md:justify-center">
                <StaticImage
                  alt="G Mining Logo"
                  src={"../../assets/g_mining_logo.svg"}
                  quality={100}
                  objectFit="cover"
                  className="w-174px"
                />
              </div>
            )}

            <div className="flex flex-col gap-8px">
              {isBigCard ? (
                <p className="text-18px leading-5 text-white">{date}</p>
              ) : (
                <p className="text-14px text-blue">{date}</p>
              )}

              <div
                className={classNames("line-clamp-2 data-text !font-bold !mb-16px", {
                  "text-blue": !isBigCard,
                  "": isBigCard,
                })}
              >
                {isBigCard ? <h3 className="mb-0 font-bold">{title}</h3> : <>{title}</>}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

const NewsSection = ({ newsData, newsTitle, newsButtonLabel, mostRecentLabel, mostRecentImage }) => {
  const isDesktop = useApplyAfterWidth(768);
  const newsSection1 = newsData.slice(0, 4);

  return (
    <Container>
      <h2 className="text-blue font-[Montserrat] leading-10 text-32px block md:hidden mb-24px">{newsTitle}</h2>

      <div className="w-full grid grid-cols-1 md:grid-cols-2">
        <div className="flex flex-col bg-beige bg-opacity-50 p-36px gap-16px rounded-b-8px md:rounded-b-none md:!rounded-l-8px">
          <div className="flex flex-col md:flex-row justify-between w-full items-center">
            <h2 className="text-blue font-[Montserrat] leading-10 text-32px mb-0 hidden md:block">{newsTitle}</h2>
            <Button
              link="/news"
              variant="beige"
              className="h-fit font-extrabold leading-6 text-18px !mt-0 !py-0 hidden md:flex"
              px="px-32px first:w-full first:md:w-fit"
              arrowClassName="!mt-0"
              buttonClassName="!mt-0 !py-0"
              arrow
              arrowRightSide
            >
              {newsButtonLabel}
            </Button>
          </div>

          <div className="flex flex-col">
            <NewsElement
              size={isDesktop ? "xs" : "sm"}
              showPreviewText={!isDesktop}
              {...newsSection1[1]}
              slug={newsSection1[1].ctaLink}
              className="w-full"
            />
            <NewsElement
              size={isDesktop ? "xs" : "sm"}
              showPreviewText={!isDesktop}
              {...newsSection1[2]}
              slug={newsSection1[2].ctaLink}
              className="w-full"
            />
            <NewsElement
              size={isDesktop ? "xs" : "sm"}
              showPreviewText={!isDesktop}
              {...newsSection1[3]}
              slug={newsSection1[3].ctaLink}
              className="w-full"
            />
          </div>

          <Button
            link="/news"
            variant="beige"
            className="h-fit !w-fit font-extrabold leading-6 text-18px !mt-0 !py-0 md:hidden"
            px="px-32px"
            arrowClassName="!mt-0"
            buttonClassName="!mt-0 !py-0"
            arrow
            arrowRightSide
          >
            {newsButtonLabel}
          </Button>
        </div>
        <div className="order-first mt-0 md:order-last rounded-b-8px md:rounded-b-none md:!rounded-r-8px">
          <NewsElement
            size={isDesktop ? "xl" : "sm"}
            showPreviewText={true}
            isBigCard
            {...newsSection1[0]}
            slug={newsSection1[0].ctaLink}
            className="w-full h-full"
            mostRecentLabel={mostRecentLabel}
            mostRecentImage={mostRecentImage}
          />
        </div>
      </div>
    </Container>
  );
};

export default NewsSection;
